module.exports = __webpack_public_path__ + "img/audio-detail-error.97958b39.png";